// extracted by mini-css-extract-plugin
module.exports = {"ownerPhotoContainer":"GreetingModal_ownerPhotoContainer__3R789","greetingModal":"GreetingModal_greetingModal__ab7wn","photoSmall":"GreetingModal_photoSmall__2FwMX"};